// Centralized OpenTelemetry identifiers for this app
export const OTEL_SERVICE_NAME = 'knab-payment-requests-web';
